/** Legal operator of the Arrangelly product (North Macedonia). */
export const LEGAL_ENTITY = {
  legalNameMk: 'АЛДЕА СИСТЕМС ДООЕЛ ОХРИД',
  legalNameEn: 'ALDEA SYSTEMS DOOEL OHRID',
  productName: 'Arrangelly',
  domain: 'arrangelly.com',
  country: 'North Macedonia',
  /** Public support / legal contact until @arrangelly.com mail is live */
  contactEmail: 'systemsaldea@gmail.com',
} as const;

/** Fixed policy revision date — update when legal text changes materially. */
export const POLICY_LAST_UPDATED = '19 May 2026';

export const LEGAL_ROUTES = {
  terms: '/terms-and-conditions',
  privacy: '/privacy-policy',
  cookies: '/cookie-policy',
  refund: '/refund-policy',
} as const;
